import { render, staticRenderFns } from "./JeecgOrderMainListForJVxeTable.vue?vue&type=template&id=a0d425d6&scoped=true"
import script from "./JeecgOrderMainListForJVxeTable.vue?vue&type=script&lang=js"
export * from "./JeecgOrderMainListForJVxeTable.vue?vue&type=script&lang=js"
import style0 from "./JeecgOrderMainListForJVxeTable.vue?vue&type=style&index=0&id=a0d425d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d425d6",
  null
  
)

export default component.exports